import { extractInvokePreviewAction } from '../../action/extract-invoke-preview-action';
export var extractPreviewClientAction = function extractPreviewClientAction(param) {
  var invokeAction = extractInvokePreviewAction(param);
  return invokeAction ? {
    invokeAction: invokeAction
  } : undefined;
};